<template>
  <!--查看-->
  <div class="room-edit-dialog" ref="room-edit-dialog">
    <el-form class="form-horizontal detail-form paddingTopDetail" :model="formData" :rules="rules" v-loading="saveLoading" ref="editForm" :label-width="'150px'" label-position="top">
      <div class="cnt-block">
        <div class="cnt-top-title">
          <div class="cnt-title">基本信息</div>
        </div>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="roomName" label="房源名称" >
              <el-input v-model.trim="formData.roomName" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="roomSize" label="经营面积" >
              <el-input v-model.trim="formData.roomSize" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="roomTypeId" label="房型" >
              <el-select class="w-p-100" v-model="formData.roomTypeId" filterable placeholder="请选择" >
                <el-option v-for="(item) in selOptions.roomType" :key="'roomTypeNa_e_'+item.id" :label="item.roomTypeName" :value="item.id"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="rentType" label="出租类型" >
              <el-select class="w-p-100" v-model="formData.rentType" filterable placeholder="请选择" >
                <el-option v-for="item in selOptions.rentType" :key="item.name" :label="item.value" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item  prop="roomNumber" label="房间号"  >
              <el-input v-model="formData.roomNumber" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="dwbgdzSfbm" label="所属省份" >
              <el-select class="w-p-100" v-model="formData.dwbgdzSfbm" filterable clearable placeholder="省" popper-class="edit-sel-popper" @change='selectedChange($event, "getCity",false)' :disabled="detailType=='edit'">
                <el-option v-for="item in wyfdzSsxqdm_provinceDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="dwbgdzSbm" label="所属市" >
              <el-select class="w-p-100" v-model="formData.dwbgdzSbm" filterable clearable placeholder="市" popper-class="edit-sel-popper" @change='selectedChange($event, "getArea")' :disabled="detailType=='edit'">
                <el-option v-for="item in wyfdzSsxqdm_cityDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="dwbgdzQbm" label="所属区（县）" >
              <el-select class="w-p-100" v-model="formData.dwbgdzQbm" filterable clearable placeholder="区（县）" popper-class="edit-sel-popper" @change='selectedChangeWithPolice($event, "getStreetOffice")' :disabled="detailType=='edit'">
                <el-option v-for="item in wyfdzSsxqdm_areaDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="addrDetail" label="详细地址：" >
              <div class="form-item-inline">
                <el-input v-model="formData.addrDetail" placeholder="请选取" readonly disabled></el-input>
                <el-button type="primary" class="pickButton"  @click="handleOpenModal(1)" :disabled="detailType=='edit'">选取</el-button>
              </div>
            </el-form-item> 
          </el-col>
          <!--<el-col :span="12">
            <el-form-item prop="xpoint_ypoint" label="房源定位：" >
              <div class="form-item-inline">
                <el-input v-model="formData.xpoint_ypoint" placeholder="请选择" ></el-input>
                <el-button type="primary" class="pickButton"  @click="handleOpenModal(1)">选取</el-button>
              </div>
            </el-form-item>
          </el-col>-->
        </el-row>
        <el-row :gutter="20">
          <el-col :span="8">
            <el-form-item prop="streetOffice" label="街道办" >
              <el-select class="w-p-100" v-model="formData.streetOffice" filterable clearable placeholder="街道办" popper-class="edit-sel-popper" @change='selectedChange($event, "getNeighborCmm")' >
                <el-option v-for="item in wyfdzSsxqdm_streetOfficeDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="neighborCmm" label="社区" >
              <el-select class="w-p-100" v-model="formData.neighborCmm" filterable clearable placeholder="社区" popper-class="edit-sel-popper">
                <el-option v-for="item in wyfdzSsxqdm_neighborCmmDicts" :key="item.areaCode" :label="item.areaName" :value="item.areaCode">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item prop="dwbgdzSsxq" label="派出所" >
              <el-select class="w-p-100" v-model="formData.dwbgdzSsxq" filterable clearable placeholder="派出所" popper-class="edit-sel-popper" >
                <el-option v-for="item in wyfdzSsxqdm_policeDicts" :key="'pp_'+item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item prop="addrCode" label="房屋编码" >
              <el-input v-model="formData.addrCode" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item  prop="briefInfo" label="简要情况" class="rowItem">
              <el-input v-model="formData.briefInfo" placeholder="请输入" type="textarea" :rows="3"  maxlength="200" show-word-limit=""></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="24">
            <el-form-item label="房屋照片" class="rowItem uploadFormItem before-dot">
              <div class="detail-box" style="flex-wrap: wrap;text-align: center; ">
                <el-upload
                  class="upload-demo"
                  :action="uploadUrl"
                  :headers="{
                    Authorization,
                  }"
                  list-type="picture-card"
                  :before-upload="beforeAvatarUpload"
                  multiple
                  :limit="4"
                  name="file"
                  :on-exceed="handleExceed"
                  :on-success="handleUploadSuccess"
                  :on-remove="handleUploadRemove"
                  :file-list="photoFileList">
                  <template #default>
                    <el-icon><plus /></el-icon>
                  </template>
                  <template #tip>
                    <div class="el-upload__tip">
                      支持jpg/png/jpeg，不超过4M，必须上传1张
                    </div>
                  </template>
                </el-upload>
              </div>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div class="blockTop">
        <div class="blockTopLine">
          <div>产权信息</div>
          <el-button v-if="ownerInfoFlag==0" @click="setOwnerInfoFlag(1)" type="text" icon="Edit"></el-button>
          <el-button class="cancelMinBtn" v-if="ownerInfoFlag==1" @click="setOwnerInfoFlag(0)" icon="Close">取消填报</el-button>
        </div>
        <div class="yellowDesc">提示补充产权信息，可增加房源审核通过率</div>
      </div>
      <el-row v-show="ownerInfoFlag==1" :gutter="20">
        <el-col :span="24">
          <el-form-item prop="propertyRadio" label="产权属性" class="rowItem" style="margin-bottom:0px;">
            <el-radio v-model="propertyRadio" label="1" >个人产权</el-radio>
            <el-radio v-model="propertyRadio" label="2">单位产权</el-radio>
          </el-form-item>
        </el-col>
      </el-row>
      <div v-show="ownerInfoFlag==1 && propertyRadio=='1'">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="ownerName" label="产权人" >
              <el-input v-model="formData.ownerName" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ownerPhone" label="联系电话" >
              <el-input v-model="formData.ownerPhone" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="ownerCountry" label="国籍" >
              <el-select class="w-p-100" v-model="formData.ownerCountry" filterable placeholder="请选择" >
                <el-option v-for="item in selOptions.ownerCountry" :key="item.name" :label="item.value" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ownerLastName" label="外文姓" >
              <el-input v-model="formData.ownerLastName" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="ownerFirstName" label="外文名" >
              <el-input v-model="formData.ownerFirstName" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ownerCertType" label="证件种类" >
              <el-select class="w-p-100" v-model="formData.ownerCertType" filterable placeholder="请选择" >
                <el-option v-for="item in selOptions.ownerCertType" :key="item.name" :label="item.value" :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="ownerCertCode" label="证件号码" >
              <el-input v-model="formData.ownerCertCode" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="realStateCode" label="不动产权证书编号">
              <el-input v-model="formData.realStateCode" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <div v-show="ownerInfoFlag==1 && propertyRadio=='2'">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="ownerCompany" label="产权单位" >
              <el-input v-model="formData.ownerCompany" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="ownerPhone" label="联系电话" >
              <el-input v-model="formData.ownerPhone" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item prop="ownerCreditCode" label="社会信用代码" >
              <el-input v-model="formData.ownerCreditCode" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item prop="realStateCode" label="不动产权证书编号">
              <el-input v-model="formData.realStateCode" placeholder="请输入" ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </div>
      <el-row :gutter="20" v-show="ownerInfoFlag==1">
        <el-col :span="24">
          <el-form-item prop="realStateCode" label="附件">
            <el-upload
              class="upload-demo-blue"
              :action="uploadUrl"
              :headers="{
                Authorization,
              }"
              :before-upload="beforeAvatarUpload"
              multiple
              :limit="1"
              name="file"
              :on-exceed="handleAttachExceed"
              :on-success="handleAttachUploadSuccess"
              :on-remove="handleAttachUploadRemove"
              :file-list="attachFileList">
              <template #tip>
                <div class="el-upload__tip">
                  房产证或租赁合同
                </div>
              </template>
              <template #default>
                <el-button class="submit-btn-blue" icon="Plus">添加附件</el-button>
              </template>
            </el-upload>
          </el-form-item>
        </el-col>
      </el-row>
      <div class="place-box"></div>
    </el-form>

    <div class="bottom-btn">
      <el-button class="submit-btn" @click="handleSave(0)" >保存</el-button>
      <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
    </div>
  
   <LocationMap :visible="locationMapDialog" :lnglat="formData.xpoint_ypoint" @close="locationMapDialog = false" @confirm="confirmLnglat" />

  </div>
</template>

<script>
  import Vue from 'vue';
  import RichText from "@/components/common/RichText/RichText";
  import {
    mapActions
  } from 'vuex'
  import moment from 'moment'
  import LocationMap from '@/components/common/locationMap/index'

  import formCheck from '@/components/common/formCheck'
  const imageConversion = require("image-conversion");
  export default {
    components: {RichText,LocationMap},
    mixins: [ formCheck],
    name: "publishDetailModel",
      props:{
        selOptions: {
          type: Object,
          default:{roomType:[],classifyValue:[],rentType:[],wyfptdwbm:[],ownerCountry:[],ownerCertType:[],jyzbm:[]},
        },
        detailModal:{
          type:Boolean,
          default:''
        },
        detailData:{
          type:Object,
          default:{}
        },
        detailType:{
          type:String,
          default:'show'
        }
      },
      data(){
        let detailKeys = ["addrCode","roomSize","addrDetail","areaCode","attachId","briefInfo","businessStatus","managerCode",
          "ownerCertCode","ownerCertType","ownerCompany","ownerCountry","ownerCreditCode","ownerFirstName",
          "ownerLastName","ownerName","ownerPhone","photoId","platformCode","policeStationCode","realStateCode",
          "rentType","roomName","roomNumber","roomSource","roomTypeId","storeId","xpoint","ypoint","dwbgdzQbm",
          "dwbgdzSbm","dwbgdzSfbm","streetOffice","neighborCmm"
        ]
        let formData = {}
        detailKeys.map((key)=>{
          formData[key] = ''
        })

        let validateTel = (rule, value, callback) => {
          if (value.trim()!='' && !this.checkTelNum(value)) {
            callback(new Error('格式错误'));
          } else {
            callback();
          }
        };
        let validateRoomNum = (rule, value, callback) => {
          if (value.trim()!='' && !this.checkRoomNum(value)) {
            callback(new Error('请输入字母和数字'));
          } else {
            callback();
          }
        };
        let validateRoomName = (rule, value, callback) => {
          if (value.trim()!='' && !this.checkCommonName(value)) {
            callback(new Error('名称必须含有汉字或字母'));
          } else {
            callback();
          }
        };

        return{
          Authorization: localStorage.getItem('Authorization'),
          ownerInfoFlag:0,
          propertyRadio: '1', // 产权属性
          locationMapDialog: false, // 百度地图选点弹框

          confirmModal:false,
          isValid:true,
          showType:'',
          regionModalType:1,
          saveLoading:false,
          detailKeys:detailKeys,
          uploadUrl:'',
          photoFileList:[],
          fileListIds:[],
          attachFileList:[],
          attachFileListIds:[],
          rules:{
            roomName:[{ required: true, message: '请输入', trigger: 'blur' },{ validator: validateRoomName, trigger: 'blur' }],
            roomSize:[{ required: true, message: '请输入', trigger: 'blur' },{ validator: this.validateNum, trigger: 'blur' ,message: '必须为大于0的数字值'}],
            roomTypeId:[{ required: true, message: '请输入', trigger: 'blur' },],
            roomNumber:[{ validator: validateRoomNum, trigger: 'blur' }],
            peopleNum:[{ required: true, message: '请输入', trigger: 'blur' },{ validator: this.validateNum, trigger: 'blur' ,message: '必须为大于0的数字值'}],
            rentType: [{ required: true, message: '请输入', trigger: 'blur' },],
            ownerPhone:[ { validator: validateTel, trigger: 'change' }],
            addrDetail:[{ required: true, message: '请选取', trigger: 'blur' },],
            ownerCreditCode:[{ min:18, max:18, message: '社会信用代码输入格式有误（18位）', trigger: 'change' },],
            dwbgdzSfbm: [{ required: true, message: '请输入', trigger: 'blur' },],
            dwbgdzSbm: [{ required: true, message: '请输入', trigger: 'blur' },],
            dwbgdzQbm: [{ required: true, message: '请输入', trigger: 'blur' },],
            streetOffice: [{ required: true, message: '请输入', trigger: 'blur' },],
            neighborCmm: [{ required: true, message: '请输入', trigger: 'blur' },],
            dwbgdzSsxq: [{ required: true, message: '请输入', trigger: 'blur' },],
          },

          wyfdzSsxqdm_provinceDicts:[],
          wyfdzSsxqdm_cityDicts:[],
          wyfdzSsxqdm_areaDicts:[],
          wyfdzSsxqdm_policeDicts:[],
          wyfdzSsxqdm_streetOfficeDicts:[],
          wyfdzSsxqdm_neighborCmmDicts:[],
          areaCodes:{},
          formData:formData
        }
    },
    created(){
      this.uploadUrl = location.origin + '/saas/api/web/fileStorage/upload'
      this.initSelData()
    },
    mounted(){
      this.showType = this.detailType
    },
    watch:{
      detailType(val){
        this.showType = val
      },
      detailModal:{
        immediate: true,
        handler: function(to){
          if(to===false){
            return false
          }
          this.$nextTick(()=>{
            this.$refs.editForm.resetFields()
            this.initFormData()
          })
        }
      },
    },
    methods:{
      ...mapActions([
        'alertToggle',
        'fetchData'
      ]),
      //重新设置rules
      setRules(){
        let val = this.formData.dwbgdzSfbm
        if(val.substr(0,2)=='66' && this.rules.streetOffice.length){
          this.rules.streetOffice = this.rules.neighborCmm = this.rules.dwbgdzSsxq = []
        }
        if(val.substr(0,2)!='66' && !this.rules.streetOffice.length){
          this.rules.streetOffice = this.rules.neighborCmm = this.rules.dwbgdzSsxq = [{ required: true, message: '请输入', trigger: 'blur' }]
        }
      },
      initFormData(){
        if(this.detailType=='add'){
          this.detailKeys.map((key)=>{
            this.formData[key] = key=='fwlyArr' ? []:''
          })

          //字典值初始化
          this.formData.ownerCountry = '156'
          //区域列表初始化
          this.wyfdzSsxqdm_cityDicts = []
          this.wyfdzSsxqdm_areaDicts = []
          this.wyfdzSsxqdm_streetOfficeDicts = []
          this.wyfdzSsxqdm_neighborCmmDicts = []
          this.wyfdzSsxqdm_policeDicts = []
          this.photoFileList = []
          this.attachFileList = []
          this.fileListIds = []
          this.attachFileListIds = []
          this.propertyRadio = '1'
        }

        if(this.detailType=='copy'){
          this.formData.fwly = '1'
        }

        if(this.detailType=='edit'||this.detailType=='copy'){
          this.detailKeys.map((key)=>{
            if(key=='fwlyArr'){
              this.formData['fwlyArr'] = this.detailData['wyfptdwbm'] ? this.detailData['wyfptdwbm'].split(','):''
            }else{
              this.formData[key] = this.detailData[key] ? this.detailData[key]:''
            }
          })
          this.formData['xpoint_ypoint'] = this.detailData['xpoint']+','+ this.detailData['ypoint']
          this.formData.dwbgdzSsxq = this.detailData.policeStationCode
          this.propertyRadio = this.detailData['ownerCompany'] ? '2':'1'
          this.ownerInfoFlag = this.detailData['ownerCompany'] || this.detailData['ownerName'] ? 1:0

          let fileList = []
          let fileIds = this.detailData.photoId.split(',')
          if(this.detailData.photoUrl && this.detailData.photoUrl.length){
            this.detailData.photoUrl.forEach((item,index)=>{
              fileList.push({name:item.substr(item.lastIndexOf('/')+1),url:item,dataId:fileIds[index]})
            })
          }
          this.photoFileList = fileList
          this.fileListIds = [...fileList]

          let attachFileList = []
          fileIds = this.detailData.attachId.split(',')
          if(this.detailData.attachIdUrl && this.detailData.attachIdUrl.length){
            this.detailData.attachIdUrl.forEach((item,index)=>{
              attachFileList.push({name:item.substr(item.lastIndexOf('/')+1),url:item,dataId:fileIds[index]})
            })
          }
          this.attachFileList = attachFileList
          this.attachFileListIds = [...attachFileList]
          //this.setRules()

          //省市区域列表初始化
          // getCity
          let p1 = this.fetchData({
            url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
            method: 'get',
            params:{ parentCode: this.detailData.dwbgdzSfbm }
          })
          //getArea
          let p2 = this.fetchData({
            url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
            method: 'get',
            params:{ parentCode: this.detailData.dwbgdzSbm }
          })
          //getStreet
          let p3 = this.fetchData({
            url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
            method: 'get',
            params:{ parentCode: this.detailData.dwbgdzQbm }
          })
          //getArea
          let p4 = this.fetchData({
            url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
            method: 'get',
            params:{ parentCode: this.detailData.streetOffice }
          })
          //getPoliceStation
          let p5 = this.fetchData({
            url:'RESOURCE.QUERY_POLICE_LIST',
            method: 'get',
            params:{ areaCode: this.detailData.dwbgdzQbm,pageSize:20000 }
          })

          Promise.all([p1, p2, p3, p4, p5]).then((res) => {
            let res1 = res[0]
            this.handleAreaChange(res[0],"getCity",true)
            this.handleAreaChange(res[1],"getArea",true)
            this.handleAreaChange(res[2],"getStreetOffice",true)
            this.handleAreaChange(res[3],"getNeighborCmm",true)
            this.handleAreaChange(res[4] ?res[4].data:[],"getPoliceStation",true)
          }).catch((err)=>{
            console.log(err,'err----')
          }).finally(()=>{
          })
        }
      },
      //删除图片
      handleUploadRemove(file, fileList){
        let key = -1
        this.fileListIds.length && this.fileListIds.forEach((item,index)=>{
          if(item.name==file.name){
            key = index
          }
        })
        this.$nextTick(()=>{
          (key>=0) && this.fileListIds.splice(key,1)
        })
      },
      //删除图片
      handleAttachUploadRemove(file, fileList){
        let key = -1
        this.attachFileListIds.length && this.attachFileListIds.forEach((item,index)=>{
          if(item.name==file.name){
            key = index
          }
        })
        this.$nextTick(()=>{
          (key>=0) && this.attachFileListIds.splice(key,1)
        })
      },
      //房源照片上传
      handleUploadSuccess(response, file, fileList){
        if(!response || !response.data || !response.data.id){
          return false
        }
        this.fileListIds.push({...file,dataId:response.data.id})
      },
      //附件上传
      handleAttachUploadSuccess(response, file, fileList){
        if(!response || !response.data || !response.data.id){
          return false
        }
        this.attachFileListIds.push({...file,dataId:response.data.id})
      },
      handleExceed(files, fileList) {
        this.$message.warning('最多上传4张房源照片');
      },
      handleAttachExceed(files, fileList) {
        this.$message.warning('最多上传1张房源照片');
      },
      beforeAvatarUpload(file) {
        let tailType = file.name.slice(file.name.lastIndexOf(".") + 1)
        let isType = ["jpeg", "jpg", "png"].indexOf(tailType.toLowerCase()) > -1
        if (!isType) {
          this.alertToggle({
            alertType: "danger",
            alertContent: "只能上传jpeg/jpg/png文件"
          })
          return false
        }

        const isLtM = file.size / 1024 / 1024 <= 4;
        if (!isLtM) {
          this.$message.error('上传附件大小不能超过 4MB!');
          return false
        }
        //return isLtM ;
        return new Promise((resolve) => {
          // 压缩到100KB,这里的100就是要压缩的大小,可自定义，imageConversion.compressAccurately(file, 100)
          //compress按比例压缩0.3
          imageConversion.compressAccurately(file, 100).then(res=>{
            resolve(res);
          })
        })
      },
      //获取图片ids
      getImageIds(typeName){
        let list = (typeName=='photoId')?this.fileListIds:this.attachFileListIds
        
        let ids = []
        list.length && list.forEach((item)=>{
          ids.push(item.dataId)
        })
        return ids.join(',')
      },
      //选择经纬度
      handleOpenModal(type) {
        // this.$refs.mapDialog.show()
        // if (this.regionModalType !== type) {
        //   this.$refs.mapDialog.reset()
        // }
        // this.regionModalType = type
        this.locationMapDialog = true
      },
      // 确认同步经纬度
      confirmLnglat(obj) {
        let addressComponents = obj.res.addressComponents
        if(!addressComponents.district){
          this.$message.error('请选取更详细的地址！')
          return false
        }
        this.formData.xpoint_ypoint = obj.lng + ',' + obj.lat
        this.formData.xpoint = obj.lng
        this.formData.ypoint =  obj.lat
        this.formData.addrDetail = obj.address || this.formData.addrDetail

        //根据详细地址回填省市区
        let params = {province:addressComponents.province,city:addressComponents.city,region:addressComponents.district}
        this.fetchData({
          url:'RESOURCE.QUERY_AREACODE_BY_NAME', 
          method: 'post', 
          params:params,
          timeout:0, 
          isLoading:false, 
          flag:true,
          headers:{'Content-Type':'application/json'}
        }).then((res)=>{
          if(res.code==200 && res.data){
            if(res.data.cityCode==this.formData.dwbgdzSbm && res.data.regionCode==this.formData.dwbgdzQbm){
              return true
            }
            this.formData.dwbgdzSfbm = res.data.provinceCode
            this.formData.dwbgdzSbm = res.data.cityCode
            this.formData.dwbgdzQbm = res.data.regionCode
            this.formData.streetOffice = ''
            this.formData.neighborCmm = ''
            this.formData.dwbgdzSsxq = '';

            // getCity
            let p1 = this.fetchData({
              url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
              method: 'get',
              params:{ parentCode: this.formData.dwbgdzSfbm }
            })
            //getArea
            let p2 = this.fetchData({
              url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
              method: 'get',
              params:{ parentCode: this.formData.dwbgdzSbm }
            })
            //getStreet
            let p3 = this.fetchData({
              url:'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
              method: 'get',
              params:{ parentCode: this.formData.dwbgdzQbm }
            })
            let p5 = this.fetchData({
              url:'RESOURCE.QUERY_POLICE_LIST',
              method: 'get',
              params:{ areaCode: this.formData.dwbgdzQbm,pageSize:20000 }
            })

            Promise.all([p1, p2, p3,  p5]).then((res) => {
              let res1 = res[0]
              this.handleAreaChange(res[0],"getCity",true)
              this.handleAreaChange(res[1],"getArea",true)
              this.handleAreaChange(res[2],"getStreetOffice",true)
              this.handleAreaChange([],"getNeighborCmm",true)
              this.handleAreaChange(res[3] ?res[3].data:[],"getPoliceStation",true)
            }).catch((err)=>{
              console.log(err,'err----')
            }).finally(()=>{
            })
          }else{
            this.$message.error('请选取更详细的地址！')
          }
          this.saveLoading = false
        }).catch((err)=>{
          this.$message.error('请选取更详细的地址！')
        }).finally (()=>{
        })
      },

      //初始化列表数据
      initSelData() {
        //区域
        let sp1 = this.fetchData({
          url: 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE',
          params: {
            parentCode: '0'
          },
          flag:true,
          method: 'get'
        })

        Promise.all([sp1]).then((rest) => {
          let rest1 = rest[0]
          let tempArr = []
          rest1 && rest1.data && rest1.data.length && rest1.data.forEach((re) => {
              if (re.areaName) {
                tempArr.push({
                  value: re.areaCode,
                  label: re.areaName,
                  areaCode: re.areaCode,
                  areaName: re.areaName
                })
              }
          })
          this['wyfdzSsxqdm_provinceDicts'] = [...tempArr]

        }).catch((err)=>{
          console.log(err,'--------------')
        }).finally(()=>{
          this.$nextTick(()=>{
            this.saveLoading = false
          })
        })
      },
      handleAreaChange(res,evt,flag){
        let tempArr = []
        res && res.length && res.forEach(re => {
          if (re.areaName) {
            tempArr.push({
              value: re.areaCode,
              label: re.areaName,
              areaCode: re.areaCode,
              areaName: re.areaName,
            })
          }
          if (re.name) {
            tempArr.push({
              value: re.policeCode,
              label: re.name,
            })
          }
        });
        if (evt === 'getCity') {
          this.wyfdzSsxqdm_cityDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.dwbgdzSbm = '';
          this.formData.dwbgdzQbm = '';
          this.formData.streetOffice = ''
          this.formData.neighborCmm = ''
          this.formData.dwbgdzSsxq = '';
        }
        if (evt === 'getArea') {
          this.wyfdzSsxqdm_areaDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.dwbgdzQbm = '';
          this.formData.streetOffice = ''
          this.formData.neighborCmm = ''
          this.formData.dwbgdzSsxq = '';
        }
        if (evt === 'getStreetOffice') {
          this.wyfdzSsxqdm_streetOfficeDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.streetOffice = ''
          this.formData.neighborCmm = ''
          this.formData.dwbgdzSsxq = '';
        }
        if (evt === 'getNeighborCmm') {
          this.wyfdzSsxqdm_neighborCmmDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.neighborCmm = ''
          this.formData.dwbgdzSsxq = '';
        }
        if (evt === 'getPoliceStation') {
          this.wyfdzSsxqdm_policeDicts = tempArr;
          if (flag) {
            return
          }
          this.formData.dwbgdzSsxq = '';
        }
      },
      //地区变了后，街道与派出所同步变化
      selectedChangeWithPolice(code, evt ,flag = false){
        this.selectedChange(code, evt ,flag)
        this.selectedChange(code, 'getPoliceStation' ,flag)
      },
      //选择切换处理
      selectedChange(code, evt ,flag = false) {
        if(evt == 'getCity'){
          //this.setRules()
        }

        let url = 'RESOURCE.FIND_AREA_LIST_BY_PARENT_CODE'
        let realCode = code
        let params = { parentCode: realCode }
        if (evt === 'getPoliceStation') {
          url = 'RESOURCE.QUERY_POLICE_LIST'
          realCode = this.formData.dwbgdzQbm
          params = { areaCode: realCode }
        }
        
        this.fetchData({
          url,
          method: 'get',
          flag:true,
          params
        }).then(res => {
          if (evt === 'getPoliceStation') {
            res = res.data || []
          }
          let tempArr = []
          res.data && res.data.forEach(re => {
            if (re.areaName) {
              tempArr.push({
                value: re.areaCode,
                label: re.areaName,
                areaCode: re.areaCode,
                areaName: re.areaName,
              })
            }
            if (re.name) {
              tempArr.push({
                value: re.policeCode,
                label: re.name,
              })
            }
          });

          if (evt === 'getCity') {
            this.wyfdzSsxqdm_cityDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.dwbgdzSbm = '';
            this.formData.dwbgdzQbm = '';
            this.formData.streetOffice = ''
            this.formData.neighborCmm = ''
            this.formData.dwbgdzSsxq = '';
          }
          if (evt === 'getArea') {
            this.wyfdzSsxqdm_areaDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.dwbgdzQbm = '';
            this.formData.streetOffice = ''
            this.formData.neighborCmm = ''
            this.formData.dwbgdzSsxq = '';
          }
          if (evt === 'getStreetOffice') {
            this.wyfdzSsxqdm_streetOfficeDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.streetOffice = ''
            this.formData.neighborCmm = ''
            this.formData.dwbgdzSsxq = '';
          }
          if (evt === 'getNeighborCmm') {
            this.wyfdzSsxqdm_neighborCmmDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.neighborCmm = ''
            this.formData.dwbgdzSsxq = '';
          }
          if (evt === 'getPoliceStation') {
            this.wyfdzSsxqdm_policeDicts = tempArr;
            if (flag) {
              return
            }
            this.formData.dwbgdzSsxq = '';
          }
        }).catch(err => {
          this.error = err
          console.log(err)
        })
      },
      handleMapSaveData(obj){
        this.formData.xpoint = obj.lng 
        this.formData.ypoint = obj.lat
        let addComp = obj.addComp
        this.formData.addrDetail = addComp.address
      },
      // 根据产权属性，清除多余数据
      confirmPropertyRadio() {
        let emptyObj = {}
        if (this.propertyRadio == 1) {
          emptyObj = {
            cqdwDwmc: '',
            ownerCreditCode: '',
            bdcqzsbh: '',
          }
        } else {
          emptyObj = {
            ownerName: '',
            ownerCountry: '',
            cqrCyzjdm: '',
            ownerCertCode: '',
            ownerLastName: '',
            ownerFirstName: ''
          }
        }
        this.formData = Object.assign(this.formData, emptyObj)
      },
      //保存与发布
      handleSave(type){
        //this.saveLoading = true
        this.trimFormData()
        this.$refs['editForm'].validate((valid) => {
          if (valid && this.isValid) {
            this.confirmPropertyRadio()
            if(!this.fileListIds || this.fileListIds.length==0){
              this.$message.error('请上传房源照片！')
              this.saveLoading = false
              return false
            }else{
              //新增
              if(this.detailType=='add' || this.detailType=='copy'){
                this.doSave(type)
                this.saveLoading = false
                return true
              }
              //修改
              this.$confirm('变更房源信息，需重新提交审核！', { type: 'warning',customClass:'zZindex' }).then(() => {
                this.doSave(type)
                this.saveLoading = false
              }).catch(() => {
                this.saveLoading = false
              })
            }
          } else {
            this.$message.error('数据输入不完整！')
            this.saveLoading = false
            return false;
          }
        });
      },
      // 获取 areaCode
      getAreaCode() {
        let areaKeys = ['neighborCmm', 'streetOffice', 'dwbgdzQbm', 'dwbgdzSbm', 'dwbgdzSfbm']
        for (let i = 0; i < areaKeys.length; i++) {
          if (this.formData[areaKeys[i]]) return this.formData[areaKeys[i]]
        }
      },
      doSave(type){
        let saveParams = {}
        this.detailKeys.forEach((name)=>{
          saveParams[name] = this.formData[name]===undefined ? '' : this.formData[name]
        })

        //此模块的注释不要删除
        saveParams['areaCode'] = this.getAreaCode()
        // saveParams['areaCode'] =  this.formData.neighborCmm
        saveParams['policeStationCode'] = this.formData.dwbgdzSsxq
        delete saveParams['dwbgdzQbm']
        delete saveParams['dwbgdzSbm']
        delete saveParams['dwbgdzSfbm']

        delete saveParams['xpoint_ypoint']
        
        saveParams['businessStatus'] = this.formData['businessStatus'] ? this.formData['businessStatus']:1
        saveParams['roomTypeId'] = this.formData['roomTypeId']*1
        let curStoreInfo = JSON.parse(localStorage.curShop)
        saveParams['storeId'] = curStoreInfo.id
        saveParams.attachId = this.getImageIds('attachId')
        saveParams.photoId = this.getImageIds('photoId')

        saveParams.ownerName = this.propertyRadio==1?saveParams.ownerName:''
        saveParams.ownerCompany = this.propertyRadio==2?saveParams.ownerCompany:''

        let url = 'SAAS.ROOM_EDIT'
        if(this.detailType=='add' || this.detailType=='copy'){
          delete saveParams.id
        }else{
          saveParams.id = this.detailData.id
        }

        let params = {...saveParams}

        this.fetchData({url:url, method: 'post', params:params,timeout:0, isLoading:false, flag:true,headers:{'Content-Type':'application/json'}}).then((res)=>{
          if(res.code==200){
            this.$message.success('操作成功！')
            this.$emit('submitSuccess')
          }else{
            this.$message.error(res.msg||'操作失败！')
          }
          this.saveLoading = false
        }).catch((err)=>{
          this.$message.error('操作失败！')
          this.saveLoading = false
        }).finally (()=>{
          this.saveLoading = false
        })
      },
      handleCancel(){
        this.$emit('closeModel')
      },
      handleConfirmCancel(){
        this.confirmModal = false
      },
      //设置产权信息标识
      setOwnerInfoFlag(flag){
        this.ownerInfoFlag = flag
        this.$nextTick(() => {
          const box = this.$refs['room-edit-dialog']
          box.scrollTop = box.scrollHeight
        }); 
      }
    },
  }
</script>

<style lang="less" scoped>
.room-edit-dialog {
  max-height: 50vh;
  display: block;
}
.bottom-btn {
  position: absolute;
  left: 50%;
  bottom: 10px;
  transform: translateX(-50%);
}
.el-collapse{
  width: 100%;
}
.form-item-inline {
  display: flex;
  align-items: center;
  width: 100%;
}
.pickButton{
  margin-left: 10px;
  height: 32px;
}
.blockTop{
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 15px;
  width: 100%;
  .blockTopLine{
    display: flex;
    flex-direction: row;
    align-items: center;
  }
  .el-button{
    color:#000;
    font-size: 12px;
    background: #ddd;
    margin-left: 10px;
  }
  .el-button--text{
    font-size: 18px;
    padding: 5px;
    color:#00c0c0;
    background: none;
  }
  .cancelMinBtn{
    border-radius: 3px !important;
    height: 23px;
    padding: 5px;
    
  }
  .yellowDesc{
    font-size: 14px;
    font-weight: normal;
  }
}
.cnt-block{
  width: 100%;
}
.cnt-title{
  font-size: 18px;
  height: 56px;
  line-height: 56px;
  flex:1;
}
.cnt-top-title{
  display: flex;
}
.yellowDesc{
  color:#f66401;
}
.submit-btn-blue{
  background: #2699f3;
  width: 100%;
  height: 100%;
  color: #fff;
}
.submit-btn-blue:deep(.el-icon){
  margin-top: 0px;
  font-size: 12px;
  color: #fff;
}
.submit-btn-blue :deep([class*=el-icon]+span){
  margin-left: 0px !important;
}
.attach-upload-demo{
  display: flex;
}
.upload-demo-blue :deep(.el-upload__tip) {
    display: inline-block;
    margin-left: 10px;
}
.before-dot :deep(.el-form-item__label::before) {
  content: "*";
  color: var(--el-color-danger);
  margin-right: 4px;
}
/*弥补滚动条异常问题*/
.place-box{
 height: 100px;
}
</style>

<style lang="less" >
.zZindex{
  z-index:3000 !important;
}
.uploadFormItem .el-form-item__content{
  display: flex;
  flex-direction: column;
  align-items: baseline;
}
</style>


